import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import type { ApiClient } from '../client';
import type { GroundHandlerOption } from '@/types/collection';

const groundHandlerOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
}) satisfies z.ZodType<GroundHandlerOption>;

export const groundHandlersQueryKey = ['groundHandlers', 'list'] as const;

/** GET /api/v1/ground-handlers. Backs the Ground handler dropdown on both driver collection pages. */
export function groundHandlersQueryOptions(api: ApiClient) {
  return queryOptions({
    queryKey: groundHandlersQueryKey,
    queryFn: async () =>
      z.array(groundHandlerOptionSchema).parse(await api.request<unknown>('/api/v1/ground-handlers')),
    staleTime: 5 * 60 * 1000,
  });
}
